import { Button } from '../../design-system/primitives/index.js'

/**
 * Amber "Time for a fresh shop" card when pantry item count is below threshold.
 * @param {{
 *   onGoShopping?: () => void,
 *   onPasteReceipt?: () => void,
 *   recipeCount?: number,
 * }} props
 */
export default function PantryLowStockBanner({
  onGoShopping,
  onPasteReceipt,
  recipeCount = 2,
}) {
  return (
    <section className="pantry-low-stock-banner" aria-labelledby="pantry-low-stock-heading">
      <div className="pantry-low-stock-banner__content">
        <p className="pantry-low-stock-banner__eyebrow">Pantry is running low</p>
        <h2 id="pantry-low-stock-heading" className="pantry-low-stock-banner__title">
          Time for a fresh shop
        </h2>
        <p className="pantry-low-stock-banner__body">
          Your staples are holding but produce and protein need restocking. Captain Cook can suggest{' '}
          <strong>{recipeCount} recipes</strong> right now — a full shop unlocks more.
        </p>
      </div>
      <div className="pantry-low-stock-banner__actions">
        {onGoShopping ? (
          <Button
            type="button"
            variant="primary"
            className="pantry-low-stock-banner__cta"
            onClick={onGoShopping}
          >
            Plan a shop →
          </Button>
        ) : null}
        {onPasteReceipt ? (
          <Button
            type="button"
            variant="secondary"
            className="pantry-low-stock-banner__secondary"
            onClick={onPasteReceipt}
          >
            Paste a receipt
          </Button>
        ) : null}
      </div>
    </section>
  )
}
